import axios from "axios";
import { base_url } from "../../utils/axiosConfig";

 


const subscribe = async (email) => {
  try {
    const response = await axios.post(`${base_url}user/subscribe/newsletter`, { email }, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 400) {
      // Check for the specific error message returned by the backend
      if (error.response.data.message === "Email is already subscribed to the newsletter.") {
        throw new Error("This email is already registered for the newsletter.");
      }
    }
    console.error("Error subscribing to newsletter:", error);
    throw new Error("Error subscribing to newsletter");
  }
};

 
 

export const authService = {

  subscribe,

};
